<template>
  <div>
    <div v-if="candidates.fetching === 'overload'" id="wrapper-mobile-size">
      <div class="mobile-size">
        <div class="wrapper-alert">
          <div class="wrap">
            <img :src="require('@/assets/images/vote/waiting.svg')">
            <h1>
              Maaf, Saat Ini Halaman E-Vote Sedang Penuh
            </h1>
            <span>Karena tingginya antusiasme dari para Rekan Alumni, mohon menunggu
              beberapa saat yaa..</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="candidates.fetching === 'resolved'" id="wrapper-mobile-size">
      <div class="mobile-size">
        <header>
          <div class="title">
            Pilih Kandidat
          </div>
        </header>
        <section style="position: relative;">
          <b-alert class="alert" show variant="dark" dismissible :show="dismissCountDown"
            @dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged"
            style="position: fixed; top: 20px; left: 0; right: 0; width: 100%; max-width: 340px; margin: 0 auto; z-index: 999; background: #202226 !important;">
            <div class="alert-body">
              <feather-icon class="mr-25" style="color: #fff;" icon="AlertCircleIcon" />
              <span class="ml-25">Anda hanya memiliki 1 kali kesempatan dalam E-vote</span>
            </div>
          </b-alert>

          <div class="info-calon-uni">
            Calon Ketua Umum ILUNI UI 2025-2028
          </div>
          <div class="wrapper-list-candidates">
            <!-- <div v-for="candidate in candidates.data" :key="candidate.id" class="candidate">
              <div class="no-urut">
                {{ candidate.no_urut }}
              </div>
              <img :src="`${candidate.photo}pilih-kandidat.png`"
                style="border-top-left-radius: 20px; border-top-right-radius: 20px;">
              <div class="candidate-name">
                {{ candidate.nama }}
              </div>
              <button @click="onSelectCandidate(candidate)">
                Pilih
              </button>
            </div> -->
            <div v-for="candidate in candidates.data" :key="candidate.id" class="list-candidates">
              <div class="no-urut">
                {{ candidate.no_urut }}
              </div>
              <img :src="`${candidate.photo}pilih-kandidat.png`">
              <div class="wrap-content">
                <div class="candidate-name">
                  {{ candidate.nama }}
                </div>
                <button @click="onSelectCandidate(candidate)">
                  Pilih
                </button>
              </div>
            </div>
          </div>
        </section>

        <div class="logout" @click="logout">
          <feather-icon class="mr-25" icon="LogOutIcon" />
          <span>Logout</span>
        </div>
      </div>
      <b-modal id="modal-popup-candidate" v-model="isPopupCandidate" centered hide-footer hide-header hide-header-close
        content-class="modal-popup-candidate" size="xs">
        <div v-if="selectedCandidate" class="wrapper-content-modal">
          <div class="wrapper-button-cancel">
            <div @click="isPopupCandidate = false, selectedCandidate = null">
              <feather-icon icon="XIcon" size="20" />
            </div>
          </div>
          <div class="wrapper-content-propup-candidate">
            <div class="wrapper-propup-no-urut">
              <div class="propup-no-urut">
                {{ selectedCandidate.no_urut }}
              </div>
              <img :src="`${selectedCandidate.photo}pilih-kandidat.png`"
                style="border-top-left-radius: 20px; border-top-right-radius: 20px;">
              <!-- <img src="https://uiconnect.sgp1.digitaloceanspaces.com/candidate-evote/demo-evote/profil-kandidat.png"
                style="border-top-left-radius: 20px; border-top-right-radius: 20px;" /> -->
            </div>
            <div class="propup-candidate-name">
              {{ selectedCandidate.nama }}
            </div>
            <button class="propup-candidate-button" @click="isPopupCandidate = false, isModalOpen = true">
              Pilih
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-default" v-model="isModalOpen" centered title="Default Modal" hide-footer hide-header
        hide-header-close content-class="modal-vote" size="xs" @hidden="onCloseHide">
        <div class="wrapper-content-modal">
          <div class="title">
            Apakah Anda yakin ingin memilih <span class="name">{{ selectedCandidate ? selectedCandidate.nama : ''
            }}</span>?
          </div>
          <div class="info">
            Kesempatan memilih hanya 1 kali dan tidak dapat diulang
          </div>
          <div class="footer">
            <div @click="isModalOpen = false"
              style="background: #e5e5e5; color: #000;  padding: 8px 16px; border-radius: 16px; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15); font-size: 16px;">
              Batalkan
            </div>
            <div
              style="background: #FEDC00; color: #000; padding: 8px 16px; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15); border-radius: 35px; border: none; font-size: 16px;"
              @click="voteCandidate">
              Ya, Saya yakin
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { BAlert } from 'bootstrap-vue'
import API from '@/api'

export default {
  components: {
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      candidates: {
        data: [],
        fetching: 'idle',
      },
      selectedCandidate: null,
      isModalOpen: false,
      isPopupCandidate: false,
    }
  },
  created() {
    this.fetchCandidate()
  },
  mounted() {
    this.showAlert()
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    async fetchCandidate() {
      try {
        this.candidates.fetching = 'pending'
        const { data } = await API.evote.candidates()
        this.candidates.data = data
        this.candidates.fetching = 'resolved'
      } catch ({ response }) {
        const statusCode = response?.status
        /* This status code is for dummy, you must first make sure the status code of the api */
        if (statusCode === 426) {
          this.candidates.fetching = 'overload'
          return;
        }
        this.candidates.fetching = 'rejected'
      }
    },
    onSelectCandidate(candidate, isGolput) {
      this.selectedCandidate = candidate
      if (isGolput) {
        this.selectedCandidate.nama = 'Tidak Memilih Kedua Kandidat'
      }
      // this.isModalOpen = true
      this.isPopupCandidate = true
    },
    onCloseHide() {
      this.selectedCandidate = null
    },
    async voteCandidate() {
      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const { data } = await API.evote.insertVote({
          candidate_id: this.selectedCandidate.id,
          election_id: this.selectedCandidate.election_id,
        })
        if (typeof data?.voter_id === 'undefined') {
          this.handleMsgErrors(data?.message)
          return
        }
        localStorage.setItem("kandidat", JSON.stringify(this.selectedCandidate))
        this.$router.replace('/vote/success')
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Gagal memilih kandidat')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async logout() {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      await this.$store.dispatch('user/logout')

      // Redirect to login page
      window.location.replace('/login/tps')
    },
  },
}
</script>


<style>
[dir] .modal .modal-content {
  border-radius: 20px !important;
}
</style>

<style scoped>
@media (max-width: 640px) {
  .mobile-size {
    width: 100vw !important;
  }

  .mobile-size header {
    display: none !important;
  }

  .mobile-size section {
    margin-top: 0 !important;
  }

  .logout {
    display: none !important;
  }

  .info-calon-uni {
    margin-top: 30px !important;
  }
}

.wrapper-list-candidates {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.list-candidates {
  width: 100%;
  max-width: calc(100% / 4.5);
  display: flex;
  flex-direction: column;
  border: 1px solid #E8E8E8;
  border-radius: 12px;
  position: relative;
  min-height: 180px;
}

.list-candidates img {
  width: 100%;
  height: auto;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.list-candidates .no-urut {
  position: absolute;
  top: 0px;
  font-size: 8px;
  border-top-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 4px 6px 4px 6px;
  background: #ffea96;
  font-weight: 700;
  color: #000;
}

.list-candidates .wrap-content {
  padding: 10px 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.list-candidates .wrap-content .candidate-name {
  margin-top: 0px;
  font-size: 10px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 5px;
}

.list-candidates .wrap-content button {
  background: #FEDC00;
  border: 0px;
  outline: none;
  border-radius: 8px;
  font-size: 11px;
  padding: 5px 0px;
  color: #111928;
  font-weight: 500;
}

.wrapper-alert {
  display: flex;
  margin: 0 auto;
  width: 100%;
  max-width: 300px;
  min-height: 80%;
  align-items: center;
}

.wrapper-alert .wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-alert img {
  width: 160px;
  margin-bottom: 16px;
}

.wrapper-alert h1 {
  color: #1B1B1B;
  text-align: center;
  display: block;
  font-size: 16px;
  margin-bottom: 16px;
}

.wrapper-alert span {
  display: block;
  text-align: center;
  color: #1B1B1B;
  font-size: 14px;
  font-weight: 500;
}

#wrapper-mobile-size {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #E5E5E5;
}

.mobile-size {
  width: 360px;
  height: 100vh;
  background-color: #F9F9F9;
  overflow-y: auto;
  position: relative;
}

.mobile-size header {
  height: 44px;
  display: flex;
  padding: 10px 10px 10px 24px;
  background-color: #FFFFFF;
  z-index: 999;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1px;
  position: fixed;
  width: 360px;
}

.mobile-size header .title {
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #1B1B1B;
}

.mobile-size section {
  margin-top: 45px;
}

.mobile-size section .alert .alert-body span {
  /* margin: 10px; */
  color: #fff;
  font-size: 16px;
}

.alert button.close {
  display: none !important;
}

.mobile-size section .wrapper-alert {
  padding: 10px 24px;
  background-color: #FFFFFF;
}

.mobile-size section .wrapper-list-candidate {
  padding: 16px 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 4.75rem;
  width: 100%;
  /* height: calc(100vh - 160px); */
  align-content: center;
  /* margin-top: 60px */
}

.candidate {
  width: 24%;
  min-height: 260px;
  background-color: #FFFFFF;
  border-radius: 20px;
  position: relative;
  border: 1px solid #E0E0E0;
  margin-bottom: 16px;
}

.candidate-name {
  margin-top: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  /* identical to box height, or 17px */
  text-align: center;
  color: #1B1B1B;
}

.candidate button {
  position: absolute;
  bottom: 0;
  margin: 0 auto;
  transform: translate(-50%, -50%);
  left: 50%;
  background: #FEDC00;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 35px;
  padding: 8px 16px;
  border: none;
  color: #000000;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
}

.candidate .no-urut {
  position: absolute;
  top: 0;
  left: -1px;
  width: 41px;
  height: 22px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  /* background: #FEDC00; */
  opacity: 0.8;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  color: #1B1B1B;
}

.candidate img {
  width: 99.9%;
  height: 135px;
}

.wrapper-content-modal {
  position: relative;
  padding: 2px;
}

.wrapper-content-modal .title {
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #1B1B1B;
}

.wrapper-content-modal .title .name {
  color: #10A8E5;
  font-weight: 900;
  font-size: 18px;
}

.wrapper-content-modal .info {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #1B1B1B;
  margin-top: 12px;
}

.wrapper-content-modal .footer {
  margin-top: 36px;
  display: flex;
  justify-content: space-between;
}

.wrapper-content-modal .footer div {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */
  text-align: center;
  cursor: pointer;
}

.wrapper-content-modal .footer .ok {
  color: #4FBBEA
}

.logout {
  position: absolute;
  bottom: 24px;
  background: #FFFFFF;
  right: 24px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;
  color: #1B1B1B;
}

.wrapper-button-cancel {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.wrapper-button-cancel div {
  cursor: pointer;
  color: #1B1B1B;
}

.wrapper-content-propup-candidate {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.wrapper-propup-no-urut {
  width: 200px;
  height: 300px;
  border-radius: 20px;
  position: relative;
}

.propup-no-urut {
  position: absolute;
  top: 0;
  left: -1px;
  background: #FEDC00;
  opacity: 0.8;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 5px 22px;
  color: #1B1B1B;
  font-weight: 600;
  font-size: 16px;
}

.wrapper-content-propup-candidate img {
  display: flex;
  width: 200px;
  height: 300px;
  object-fit: cover;
  border-radius: 20px;
}

.wrapper-content-propup-candidate .propup-candidate-name {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  margin-top: 16px;
}

.wrapper-content-propup-candidate .propup-candidate-button {
  background: #FEDC00;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 35px;
  padding: 12px 16px;
  border: none;
  color: #000000;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 16px;
}

.info-calon-uni {
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  padding-bottom: 15px;
  margin-top: 60px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
</style>